import { Layout } from 'antd';
import { workSpaceSelectors } from 'containers/App/selectors';
import { getUserInfo } from 'pages/Dashboard/thunks';
import React, { Suspense, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { Route, Switch } from 'react-router-dom';
import { navigations } from 'routes/navigations';
import { Loading } from 'components';
import { getWorkspace } from '../../pages/LoginPage/thunk';
import SideBar from './components/SideBar';
import TopBar from './components/TopBar';
import { Wrap } from './styles';

const { Header, Content, Sider } = Layout;

const MyLayout: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { userInfo } = useSelector(workSpaceSelectors);

  const storage = localStorage['token'];
  useEffect(() => {
    if (!localStorage['token']) {
      history.push('/login');
    }
  }, [storage, history]);

  useEffect(() => {
    dispatch(getWorkspace());
    dispatch(getUserInfo());
  }, [dispatch]);

  const checkAdmin = userInfo && userInfo.user_groups.find((g: any) => g.group_id === 'admin');

  return (
    <Wrap>
      <Layout>
        <Header className="header">
          <TopBar />
        </Header>
        <Layout>
          {checkAdmin && (
            <Sider width={300} className="side">
              <SideBar />
            </Sider>
          )}
          <Layout>
            <Content className="content">
              <Suspense fallback={Loading}>
                <Switch>
                  {navigations.map((item, index) => {
                    if (!checkAdmin && item.path !== '/') {
                      return <Redirect to="/" />;
                    }
                    return <Route key={index} path={item.path} component={item.component} exact={item.exact} />;
                  })}
                </Switch>
              </Suspense>
            </Content>
          </Layout>
        </Layout>
      </Layout>
    </Wrap>
  );
};

export default MyLayout;
